import { render, staticRenderFns } from "./FoundationTitleTransfer.vue?vue&type=template&id=4a3d661c"
import script from "./FoundationTitleTransfer.vue?vue&type=script&lang=js"
export * from "./FoundationTitleTransfer.vue?vue&type=script&lang=js"
import style0 from "./FoundationTitleTransfer.vue?vue&type=style&index=0&id=4a3d661c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports